/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationStatus
 */
export interface IntegrationStatus {
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    lastSuccessfulUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    nextUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationStatus
     */
    error?: string | null;
}

/**
 * Check if a given object implements the IntegrationStatus interface.
 */
export function instanceOfIntegrationStatus(value: object): value is IntegrationStatus {
    return true;
}

export function IntegrationStatusFromJSON(json: any): IntegrationStatus {
    return IntegrationStatusFromJSONTyped(json, false);
}

export function IntegrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'lastSuccessfulUpdate': json['lastSuccessfulUpdate'] == null ? undefined : json['lastSuccessfulUpdate'],
        'nextUpdate': json['nextUpdate'] == null ? undefined : json['nextUpdate'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'status': json['status'] == null ? undefined : json['status'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function IntegrationStatusToJSON(json: any): IntegrationStatus {
    return IntegrationStatusToJSONTyped(json, false);
}

export function IntegrationStatusToJSONTyped(value?: IntegrationStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'lastSuccessfulUpdate': value['lastSuccessfulUpdate'],
        'nextUpdate': value['nextUpdate'],
        'timeZone': value['timeZone'],
        'status': value['status'],
        'error': value['error'],
    };
}

